module.exports = __webpack_public_path__ + "img/set_theme_3.8627c060.png";